import Dialog from "@mui/material/Dialog";
import { position_config } from "./sy-modal-config";
import { ModalProps } from "./sy-modal-interface";
import { Slide } from "@mui/material";
import { forwardRef, memo } from "react";

const SyPopup = (props: ModalProps) => {
  const {
    open = false,
    onClose = () => void 0,
    fullScreen = false,
    children = "",
    scroll = "paper",
    maxWidth = "sm", // can be 'sm', false, or custom like '800px'
    position = "center",
    transitionDirection = "",
    backDrop = true,
    ...rest
  } = props;

  const isStandardSize = ['xs', 'sm', 'md', 'lg', 'xl', false].includes(maxWidth);

  const transparentPaper = {
    style: {
      backgroundColor: "transparent",
      boxShadow: "none",
      // border: "1px solid white",
      // marginTop: "100px",
      ...(isStandardSize ? {} : {
        maxWidth: typeof maxWidth === "string" ? maxWidth : undefined,
        width: "100%",
      }),
    },
  };

  const TransitionComponent = forwardRef((transitionProps: any, ref) => (
    <Slide direction={transitionDirection} ref={ref} {...transitionProps} />
  ));

  const handleClose = (event: any, reason: any) => {
    if (reason === 'backdropClick') return;
    onClose();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      scroll={scroll}
      fullWidth
      maxWidth={isStandardSize ? (maxWidth as any) : false}
      onClose={backDrop ? handleClose : onClose}
      BackdropProps={{
        sx: {
          backdropFilter: "blur(5px)",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
        },
      }}
      sx={position_config[position]}
      PaperProps={transparentPaper}
      TransitionComponent={transitionDirection ? TransitionComponent : undefined}
      {...rest}
    >
      {children}
    </Dialog>
  );
};

export default memo(SyPopup);
